interface HideWordLimitProps {
  docName: string;
  limit: number;
}

export function hideDocNameMidPart({ docName, limit }: HideWordLimitProps) {
  const halfOfLimit = limit / (4 / 3);

  const lastDotIndex = docName.lastIndexOf('.');

  const nameWithoutExtension = docName.slice(0, lastDotIndex);
  if (nameWithoutExtension.length <= limit) {
    return docName;
  }
  const extension = docName.slice(lastDotIndex);

  const start = nameWithoutExtension.slice(0, halfOfLimit - 1);
  const end = nameWithoutExtension.slice(-(limit - halfOfLimit));

  return `${start}...${end}${extension}`;
}
